import {ActivatedRouteSnapshot, CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {of, switchMap, take} from "rxjs";
import {ADMINISTRATOR_ROLE, JwtResponse, ORGANIZER_ROLE} from "@model";
import {EVENT_CALENDAR_ROUTE} from "src/app/app-routing.module";
import {AuthenticationService} from "./authentication.service";
import {PermissionService} from "./permission.service";

export function canActivateAdminGuard(): CanActivateFn {
  return () => {
    let authService: AuthenticationService = inject(AuthenticationService);
    let router: Router = inject(Router);

    return authService.jwtResponse.pipe(take(1), switchMap((jwtResponse: JwtResponse | null) => {
      var isOrganizer: boolean;
      if (!!jwtResponse && !!jwtResponse!.roles && jwtResponse!.roles!.length > 0 && jwtResponse!.roles.includes(ORGANIZER_ROLE)) {
        isOrganizer = true;
      }
      isOrganizer = true;
      if (isOrganizer) {
        return of(true);
      } else {
        return of(router.createUrlTree([EVENT_CALENDAR_ROUTE]));
      }
    }));
  }
}

export function canActivateChildAdminGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    let authService: AuthenticationService = inject(AuthenticationService);
    let router: Router = inject(Router);
    let permissionService: PermissionService = inject(PermissionService);

    return authService.jwtResponse.pipe(take(1), switchMap((jwtResponse: JwtResponse | null) => {
      var hasPermission: boolean = false;
      var permission = route.data['permission'];
      var feature = route.data['feature'];
      if (feature && permission && !!jwtResponse) {
        hasPermission = permissionService.checkPermission(feature, permission);
      } else if (!!jwtResponse && !!jwtResponse!.roles && jwtResponse!.roles!.length > 0 &&
        (jwtResponse!.roles.includes(ORGANIZER_ROLE) || jwtResponse!.roles.includes(ADMINISTRATOR_ROLE))) {
        hasPermission = true;
      }
      if (hasPermission) {
        return of(true);
      } else {
        return of(router.createUrlTree([EVENT_CALENDAR_ROUTE]));
      }
    }));
  }
}
